import { Day } from '@app/forms/formly/types/range-picker-dropdown/range-picker/range-picker.component';

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function formatDayToString(obj: Day): string {
  const monthName = months[obj.month];
  return `${monthName} ${obj.date}`;
}

export function formatStringToDay(dayString: string): Day | undefined {
  if (!dayString) {
    return;
  }

  if (!isValidDateString(dayString)) {
    return;
  }

  const [monthName, dateString] = dayString.split(' ');
  const month = months.indexOf(monthName);

  if (month === -1 || !dateString) {
    return;
  }

  const date = +dateString;

  return { month, year: defineYear(month, date), date: parseInt(dateString, 10) };
}

export function isValidDateString(dateString: string): boolean {
  if (!dateString) {
    return false;
  }

  const [month, day] = dateString.split(' ');

  if (!month || !day) {
    return false;
  }

  const monthIndex = months.findIndex((m) => m === month);

  const year = defineYear(+month, +day);
  const daysInMonth = [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  if (monthIndex === -1) {
    return false;
  }

  const dayNumber = parseInt(day, 10);
  return dayNumber > 0 && dayNumber <= daysInMonth[monthIndex];
}

export function isLeapYear(year: number): boolean {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

function defineYear(month: number, date: number): number {
  const now = new Date();
  let year = now.getFullYear();

  if (month < now.getMonth() || (month === now.getMonth() && date < now.getDate())) {
    year++;
  }

  return year;
}

export function formatStringToDate(dayString: string): Date | undefined {
  const date = formatStringToDay(dayString);

  if (!date) {
    return;
  }

  return new Date(date.year, date.month, date.date);
}
